// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, select } from 'redux-saga/effects';
import { isGymboree, isCanada, isTCP, isPJP, isSNJ } from '@tcp/core/src/utils/utils';
import logger from '../../../../../utils/loggerInstance';
import emailSignupAbstractor from '../../../../../services/abstractors/common/EmailSmsSignup/EmailSmsSignup';
import { emailSignupStatus } from './Checkout.action';
import constants, { CHECKOUT_ROUTES } from '../Checkout.constants';
import briteVerifyStatusExtraction from '../../../../../services/abstractors/common/briteVerifyStatusExtraction';
import utility from '../util/utility';
import { getWcsSubscribeEmailEnabled } from '../../../../../reduxStore/selectors/session.selectors';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import selectors from '../../Confirmation/container/Confirmation.selectors';

export function* subscribeEmailAddress(emailObj, status, field1) {
  const { payload, status: resStatus } = emailObj;
  const { component } = payload;
  const wcsFlagForEmailSignUp = yield select(getWcsSubscribeEmailEnabled);
  let brandGYM = !!(isGymboree() || payload.isEmailOptInSecondBrand);
  let brandTCP = !!(isTCP() || payload.isEmailOptInSecondBrand);
  let brandSNJ = !!isSNJ();
  let brandPJP = !!isPJP();
  if (payload.isCheckoutFow) {
    const { brandGYM: GYM, brandTCP: TCP, brandSNJ: SNJ, brandPJP: PJP } = payload;
    brandGYM = GYM;
    brandTCP = TCP;
    brandSNJ = SNJ;
    brandPJP = PJP;
  }

  const responseStatus = status || resStatus;
  const getShippingAddress = yield select(BagPageSelectors.getCompleteShippingAddress);
  const allShipments = yield select(selectors.getAllShipments);
  const shippingDetails = allShipments?.[0];
  const {
    shippingAddress: {
      firstName = '',
      lastName = '',
      postalCode = '',
      c_storeName: storeName = '',
    } = {},
  } = shippingDetails || {};
  const zipcode = !storeName ? postalCode : '';

  try {
    const payloadObject = {
      URL: 'email-confirmation',
      response: payload.isCheckoutFow ? responseStatus : `${responseStatus}::false:false`,
      brandTCP,
      brandGYM,
      brandSNJ,
      brandPJP,
      firstName: getShippingAddress?.givenName || firstName || '',
      lastName: getShippingAddress?.familyName || lastName || '',
      zipCode: getShippingAddress?.postalCode || zipcode || '',
    };
    if (wcsFlagForEmailSignUp) {
      payloadObject.emailaddr = payload.signup;
    } else {
      payloadObject.emailAddr = payload.signup;
    }

    payloadObject.registrationType = constants.EMAIL_REGISTRATION_TYPE_CONSTANT;
    if (field1) {
      payloadObject.field1 = field1;
    }
    const res = yield call(
      emailSignupAbstractor.subscribeEmail,
      payloadObject,
      wcsFlagForEmailSignUp
    );
    yield put(emailSignupStatus({ subscription: { ...res, component } }));
  } catch (err) {
    logger.error(err);
  }
}

export function* validateAndSubmitEmailSignup(
  emailAddress,
  field1,
  brandTCP,
  brandGYM,
  brandSNJ,
  brandPJP
) {
  if (emailAddress) {
    const statusCode = yield call(briteVerifyStatusExtraction, emailAddress);
    yield subscribeEmailAddress(
      {
        payload: {
          signup: emailAddress,
          isCheckoutFow: true,
          brandGYM,
          brandTCP,
          brandSNJ,
          brandPJP,
        },
      },
      statusCode,
      field1
    );
  }
}

export function* submitEmailSignup(emailAddress, formData) {
  const isCaSite = yield call(isCanada);
  if (isCaSite && emailAddress && (formData.emailSignUpTCP || formData.emailSignUpGYM)) {
    yield validateAndSubmitEmailSignup(
      emailAddress,
      undefined,
      formData.emailSignUpTCP,
      formData.emailSignUpGYM
    );
  }
}

export const pickUpRouting = ({
  getIsShippingRequired,
  isVenmoInProgress,
  isVenmoPickupDisplayed,
}) => {
  if (getIsShippingRequired) {
    utility.routeToPage(CHECKOUT_ROUTES.shippingPage);
  } else if (isVenmoInProgress && !isVenmoPickupDisplayed) {
    utility.routeToPage(CHECKOUT_ROUTES.reviewPage);
  } else {
    utility.routeToPage(CHECKOUT_ROUTES.billingPage);
  }
};
